import { motion } from "framer-motion";
import Overline from "./Overline";
import { reveal, revealStaggered, VIEW_40, VIEW_80 } from "./motion";

const CAPABILITIES = [
  { id: "01", name: "Digital Experiences", desc: "Immersive WebGL brand destinations and interactive scrollytelling web apps." },
  { id: "02", name: "Creative Technology", desc: "Custom shader engineering, generative AI integration, and real-time audio-visual engines." },
  { id: "03", name: "3D Design & Motion", desc: "Cinematic 3D asset creation, photorealistic renders, and fluid motion choreography." },
  { id: "04", name: "Innovation Labs", desc: "Prototyping spatial computing, AR web experiences, and next-gen interaction models." },
  { id: "05", name: "Interactive Solutions", desc: "High-density data visualization, interactive dashboards, and touchpoint design systems." },
];


export const AboutCapabilityList = () => (
  <section data-testid="about-capabilities" className="px-6 py-28 md:px-16 lg:px-24">
    <motion.div variants={reveal} initial="hidden" whileInView="show" viewport={VIEW_80}>
      <Overline>What We Do</Overline>
      <h2 className="font-display max-w-3xl text-3xl font-bold leading-tight text-[#F4F6FB] md:text-5xl">
        Capabilities, tuned like instruments.
      </h2>
    </motion.div>
    <div className="mt-16">
      {CAPABILITIES.map((c, i) => (
        <motion.div
          key={c.id}
          data-testid={`about-capability-${c.id}`}
          variants={revealStaggered}
          initial="hidden"
          whileInView="show"
          viewport={VIEW_40}
          custom={i * 0.08}
          className="group grid items-baseline gap-2 border-t border-white/10 py-8 transition-colors duration-500 last:border-b hover:border-[#8B5CF6]/40 md:grid-cols-[6rem_1fr_2fr] md:gap-8"
        >
          <span className="font-mono text-xs tracking-[0.3em] text-[#D4AF37]">{c.id}</span>
          <h3 className="font-display text-xl font-semibold text-[#F4F6FB] transition-colors duration-300 group-hover:text-[#8B5CF6] md:text-2xl">
            {c.name}
          </h3>
          <p className="text-sm leading-relaxed text-[#F4F6FB]/55">{c.desc}</p>
        </motion.div>
      ))}
    </div>
  </section>
);

export default AboutCapabilityList;
